import styled from '@emotion/styled';
import { blueActiveColor, blueDisabledColor, blueEnabledColor } from './colors';

export const LinkButton = styled.div((props) => {
  let style = {
    color: blueEnabledColor,
    cursor: 'pointer',
    fontSize: '12px',
    textAlign: 'center',
    ':hover': {
      textDecoration: 'underline'
    },
    ':hover:active': {
      color: blueActiveColor,
      textDecoration: 'underline'
    }
  };
  if (props.disabled) {
    style.backgroundColor = blueDisabledColor;
    style.pointerEvents = 'none';
  }
  return style;
});



// WEBPACK FOOTER //
// ./src/styles/LinkButton.js